import { Component, Input } from '@angular/core';
import { SlicePipe } from '@angular/common';

@Component({
    selector: 'app-section-title',
    templateUrl: './section-title.component.html',
    imports: [SlicePipe]
})
export class SectionTitleComponent {
  @Input() title: string;
  @Input() count: number;
  @Input() countId?: string;
  @Input() dataCount: number;
}
